module.exports = __webpack_public_path__ + "static/media/listing-page-karjat.15d450a3.jpg";